import { Injectable } from '@angular/core';
import {
  UrlTree,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CheckIfModalOpenGuard implements CanActivateChild {

  isNative = Capacitor.getPlatform() !== 'web';

  constructor(
    private modal: ModalController,
    private alert: AlertController,
    private location: Location,
  ) {
  }


  private pushHistory(state: RouterStateSnapshot) {
    this.location.go(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.isNative) return true;
    const promiseArray = Promise.all([
      this.modal.getTop(),
      this.alert.getTop(),
    ]);
    return promiseArray.then(async ([modalRef, alertRef]) => {
      const modalExist = modalRef && modalRef['s-p'].length;
      if (modalExist) await modalRef.dismiss();
      if (alertRef) await alertRef.dismiss();
      const shouldProceed = !(modalExist || alertRef);
      if (!shouldProceed) {
        this.pushHistory(state);
      }
      return shouldProceed;
    });
  }
}
